export default __webpack_public_path__ + "a8190bd96f842bac3721aa805491a473.ply";